
import React, { useState, useEffect, Fragment, useRef } from "react";
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import {

    makeStyles,
    createStyles,
} from "@material-ui/core/styles";
import validator from 'validator';
import { useTheme } from '@mui/material/styles';
import CloseIcon from "@material-ui/icons/Close";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, getDateString } from "../../utilities/utility";
import { checkUserAccess, getCheckSession } from "../../apis/auth";
import { Backdrop, Box, Button, Checkbox, CircularProgress, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormHelperText, FormLabel, IconButton, InputLabel, Menu, MenuItem, Paper, Radio, RadioGroup, Select, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tabs, TextField, Typography, useMediaQuery } from "@material-ui/core";
import { addUser, getAllDisplayNames, getAllPermissionConfig, getAllUser, updatePermissionConfig, addPermissionConfig, updateUser } from "../../query/users.query";
import { NotificationManager } from "react-notifications";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddIcon from '@mui/icons-material/Add';

const useStyles = makeStyles((theme) =>
    createStyles({
        button: {
            margin: theme.spacing(1),
        },
        table: {
            minWidth: 650,
        },
        root: {
            width: "100%",
        },
        instructions: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            marginRight: 20,
        },
        closeButton: {
            position: "absolute",
            right: theme.spacing(2),
            top: theme.spacing(2),
            color: theme.palette.grey[500],
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
        tab: {
            '& .MuiTabPanel-root': {
                padding: '0px',
            },
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            opacity: 0.5,
        },
    })
);

const PermissionConfig = () => {
    const classes = useStyles();
    const history = useHistory();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [opReportData, setOpReportData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    //field name
    const [name, setName] = useState('');
    const [key, setKey] = useState('');
    const [status, setStaus] = useState(null);
    const [group, setGroup] = useState('');
    const [description, setDescription] = useState('');
    const [type, setType] = useState('');
    const [typeList, setTypeList] = useState([]);
    const [groupList, setGroupList] = useState([]);

    //error field name
    const [nameError, setNameError] = useState('');
    const [keyError, setKeyError] = useState('');
    const [statusError, setStausError] = useState('');
    const [groupError, setGroupError] = useState('');
    const [addGroupError, setAddGroupError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [addTypeError, setAddTypeError] = useState('');
    const [openDialog, setOpenDialog] = useState(null);

    useEffect(async () => {
        console.log("========== LiveMeterFeed : OnInit() ==========");
        var sessionStatus = await getCheckSession();
        if (sessionStatus === false) {
            history.push("/");
            return;
        }
        UpdateSlcTable();
        getAllData();
    }, []);

    const getAllData = async () => {
        await getAllPermissionConfig().then((data) => {
            // opReportData([...data.cma.map(item => ({ ...item, type: 'web' })), ...data.cma.map(item => ({ ...item, type: 'cma' })), ...data.vista.map(item => ({ ...item, type: 'vista' }))])
            const groupKeys = Object.keys(data);
            let type = [];
            const transformedData = groupKeys.flatMap(groupKey => {
                type.push(groupKey);
                return data[groupKey].map(item => ({
                    ...item,
                    type: groupKey
                }));
            });
            const uniqueData = Array.from(new Map(transformedData.map(item => [item.group, item])).values());
            setGroupList(uniqueData.map(item => item.group))
            setTypeList(type);
            setOpReportData(transformedData);
        })
    }

    const hideAddUserDialog = () => {
        setIsAddingNewType(false)
        setNameError('')
        setOpenDialog(null)
        setSelectedRow(null)
        setName('');
        setStaus(null)
        setKey('');
        setGroup('');
        setDescription('');
        setType('');
        setNameError('');
        setGroupError('');
        setKeyError('');
        setStausError('');
        setTypeError('');
        setDescriptionError('');
    }

    const update = () => {
        var error = false;
        if (name.trim() == "" || name.trim().length <= 0) {
            setNameError("Enter name");
            error = true;
        } else {
            setNameError("");
        }
        if (status == null) {
            setStausError("Enter status");
            error = true;
        } else {
            setStausError("");
        }
        if (group == "" || group.length <= 0) {
            setGroupError("Select group");
            error = true;
        } else {
            setGroupError("");
        }
        if (description.trim() == "" || description.trim().length <= 0) {
            setDescriptionError("Enter description");
            error = true;
        } else {
            setDescriptionError("");
        }
        if (type == "" || type.length <= 0) {
            setTypeError("Enter type");
            error = true;
        } else {
            setTypeError("");
        }
        const keyExists = opReportData.some((e) => e.key === key);
        if (keyExists && key !== selectedRow.key) {
            setKeyError("Key is already exits");
            error = true;
        } else {
            if (key.trim() == "" || key.trim().length <= 0) {
                setKeyError("Enter key");
                error = true;
            } else {
                setKeyError("");
            }
        }
        if (error) {
            return;
        }
        const updateData = {
            type: type,
            [type]: [{
                description: description,
                group: group,
                key: key,
                name: name,
                status: status,
            }]
        };
        // alert(JSON.stringify(updateData));
        // return;
        updatePermissionConfig(updateData, selectedRow.key).then((e) => {
            getAllData();
            hideAddUserDialog();
            NotificationManager.success("Permisstion updated successfully", "", 3000);
        }).catch((e) => {
            alert(e)
            NotificationManager.error("Unable to update permission", "", 3000);
        });
    }

    // var dataa =
    // {
    //   "web": [
    //     {
    //       "description": "Enable all database",
    //       "key": "all_db",
    //       "group": "db list",
    //       "status": true,
    //       "name": "All database"
    //     },
    //     {
    //       "description": "Enable dashboard map",
    //       "key": "map_update",
    //       "group": "map",
    //       "status": true,
    //       "name": "map update"
    //     },
    //     {
    //       "description": "Enable  schedule",
    //       "key": "schedule",
    //       "group": "settings",
    //       "status": true,
    //       "name": "schedule"
    //     },
    //     {
    //       "description": "Enable view access for ticket",
    //       "key": "ticket",
    //       "group": "ticket",
    //       "status": true,
    //       "name": "ticket"
    //     },
    //     {
    //       "description": "Enable to access the create ticket",
    //       "key": "create_ticket",
    //       "group": "ticket",
    //       "status": true,
    //       "name": "create ticket"
    //     },
    //     {
    //       "description": "Enable to access the reopen ticket",
    //       "key": "reopen_ticket",
    //       "group": "ticket",
    //       "status": true,
    //       "name": "reopen ticket"
    //     },
    //     {
    //       "description": "Enable to access the resolve ticket",
    //       "key": "resolve_ticket",
    //       "group": "ticket",
    //       "status": true,
    //       "name": "resolve ticket"
    //     },
    //     {
    //       "description": "Enable to access the edit cofig",
    //       "key": "edit_config",
    //       "group": "config",
    //       "status": true,
    //       "name": "edit config"
    //     },
    //     {
    //       "description": "Enable to access the edit slc1 cofig",
    //       "key": "view_config_slc1",
    //       "group": "config",
    //       "status": true,
    //       "name": "view config slc1"
    //     },
    //     {
    //       "description": "Enable to access the view config slc3",
    //       "key": "view_config_slc3",
    //       "group": "config",
    //       "status": true,
    //       "name": "view config slc3"
    //     },
    //     {
    //       "description": "Enable to access the view config ilm",
    //       "key": "view_config_ilm",
    //       "group": "config",
    //       "status": true,
    //       "name": "view config ilm"
    //     },
    //     {
    //       "description": "Enable to access the view config",
    //       "key": "view_config",
    //       "group": "config",
    //       "status": true,
    //       "name": "view config"
    //     },
    //     {
    //       "description": "Enable to access the view inventory slc",
    //       "key": "inventory_slc",
    //       "group": "inventory",
    //       "status": true,
    //       "name": "view inventory slc"
    //     },
    //     {
    //       "description": "Enable to access the view inventory ilm",
    //       "key": "inventory_ilm",
    //       "group": "inventory",
    //       "status": true,
    //       "name": "view inventory ilm"
    //     },
    //     {
    //       "description": "Enable to access the view inventory lamp",
    //       "key": "inventory_lamp",
    //       "group": "inventory",
    //       "status": true,
    //       "name": "view inventory lamp"
    //     },
    //     {
    //       "description": "Enable to access the view inventory summary",
    //       "key": "inventory_summary",
    //       "group": "inventory",
    //       "status": true,
    //       "name": "view inventory summary"
    //     }
    //   ]
    // };

    const add = () => {
        var error = false;
        if (name.trim() == "" || name.trim().length <= 0) {
            setNameError("Enter name");
            error = true;
        } else {
            setNameError("");
        }

        if (status == null) {
            setStausError("Enter status");
            error = true;
        } else {
            setStausError("");
        }
        if (group == "" || group.length <= 0) {
            setGroupError("Select group");
            error = true;
        } else {
            setGroupError("");
        }
        if (description.trim() == "" || description.trim().length <= 0) {
            setDescriptionError("Enter description");
            error = true;
        } else {
            setDescriptionError("");
        }
        if (type == "" || type.length <= 0) {
            setTypeError("Enter type");
            error = true;
        } else {
            setTypeError("");
        }
        const keyExists = opReportData.some((e) => e.key === key);
        if (keyExists) {
            setKeyError("Key is already exits");
            error = true;
        } else {
            if (key.trim() == "" || key.trim().length <= 0) {
                setKeyError("Enter key");
                error = true;
            } else {
                setKeyError("");
            }
        }
        if (error) {
            return;
        }


        const updateData = {
            type: type,
            [type]: [{
                description: description,
                group: group,
                key: key,
                name: name,
                status: status
            }]
        };

        addPermissionConfig(updateData).then((e) => {
            getAllData();
            NotificationManager.success("Permisstion created successfully", "", 3000);
            hideAddUserDialog();
        }).catch((e) => {
            alert(e)
            NotificationManager.error("Unable to create permission", "", 3000);
        });
    }

    const getOpReportColumnList = () => {
        return [
            {
                title: 'Type',
                field: 'type',
                searchable: true,
                render: ({ type: type = "" }) => {
                    return type;
                },
                exportTransformer: ({ type: type = "" }) => {
                    return type
                }
            },
            {
                title: 'group',
                field: 'group',
                render: ({ group: group = "" }) => {
                    return group;
                },
                exportTransformer: ({ group: group = "" }) => {
                    return group
                }
            },
            {
                title: 'key',
                field: 'key',
                render: ({ key: key = "" }) => {
                    return key;
                },
                exportTransformer: ({ key: key = "" }) => {
                    return key
                }
            },
            {
                title: 'name',
                field: 'name',
                render: ({ name: name = "" }) => {
                    return name;
                },
                exportTransformer: ({ name: name = "" }) => {
                    return name
                }
            },
            {
                title: 'status',
                field: 'status',
                cellStyle: {
                    whiteSpace: 'nowrap'
                },
                render: ({ status: status = false }) => {
                    return status ? "True" : "False";
                },
                exportTransformer: ({ status: status = false }) => {
                    return status ? "True" : "False";
                }
            },
            {
                title: 'Description',
                field: 'description',
                cellStyle: {
                    whiteSpace: 'nowrap'
                },
                render: ({ description: description = "" }) => {
                    return description;
                },
                exportTransformer: ({ description: description = "" }) => {
                    return description
                }
            },
            // {
            //     title: 'Edit',
            //     width: 200,
            //     render: rowData => (
            //         <div className="flex gap-2">
            //             <Button
            //                 variant="outlined"
            //                 className="px-3 py-1 text-blue-600 border-blue-600 hover:bg-blue-50"
            //                 onClick={() => {
            //                     setSelectedRow(rowData);
            //                     setName(rowData.name);
            //                     setKey(rowData.key);
            //                     setGroup(rowData.group);
            //                     setDescription(rowData.description);
            //                     setType(rowData.type);
            //                     setStaus(rowData.status ? 'Active' : "Deactive");
            //                 }}
            //             >
            //                 Edit
            //             </Button>
            //         </div >
            //     )
            // }
        ];

    };

    async function UpdateSlcTable() {
        await getAllUser().then((data) => { setOpReportData(data); }).catch((e) => { });
    }
    const [isAddingNewType, setIsAddingNewType] = useState(false);
    const [isAddingNewGroup, setIsAddingNewGroup] = useState(false);

    const handleInputChange = (e) => {
        setType(e.target.value);
        setTypeError('');
    };

    const handleAddType = () => {
        if (type.trim()) {
            if (!typeList.includes(type)) {
                setTypeList([...typeList, type]);
                setIsAddingNewType(false);
            } else {
                setTypeError('This option already exists');
            }
        }
    };

    return (
        <div className="reports">

            <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                boxSizing: "border-box",
            }}>
                <h2  >Permission List</h2>
                <Button style={{
                    backgroundColor: "#0071CE",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                }}
                    onClick={() => { setOpenDialog(true); }}
                >
                    Add Permission
                </Button>
            </div>
            {/* <div className="flex flex-col mb-4">
                <div className="flex justify-start">
                    <h2 className="text-2xl font-semibold"></h2>
                </div>
                <div className="flex justify-end">
                    <Button
                        variant="contained"
                        onClick={() => { setOpenDialog(true); }}
                        className="capitalize"
                        style={{
                            display: 'flex',
                            textTransform: "none",
                            fontSize: "1.2em",
                            padding: "5px 10px"
                        }}
                    >
                    </Button>
                </div>
            </div> */}
            <Box sx={{ width: '100%', typography: 'body1' }}>
                <div className="dashboard-table">
                    <MaterialTable
                        style={{
                            margin: "20px 0",
                            width: "100%",
                        }}
                        className={classes.table}
                        title=""
                        columns={getOpReportColumnList()}
                        data={opReportData}
                        actions={[
                            {
                                icon: 'edit',
                                iconProps: { color: "action" },
                                tooltip: 'Edit Dim Schedule',
                                onClick: (event, rowData) => {
                                    setSelectedRow(rowData);
                                    setName(rowData.name);
                                    setKey(rowData.key);
                                    setGroup(rowData.group);
                                    setDescription(rowData.description);
                                    setType(rowData.type);
                                    setStaus(rowData.status ? 'Active' : "Deactive");
                                }
                            },
                            // {
                            //     icon: 'delete',
                            //     tooltip: 'Delete Dim Schedule',
                            //     onClick: (event, rowData) => {

                            //     }
                            // },
                        ]}
                        options={{
                            exportButton: true,
                            exportAllData: true,
                            exportCsv: (columns, csvData) => { exportMaterialTableToExcel(columns, csvData, `Energy Saving Report-${getDateString()}`); },
                            exportPdf: (columns, csvData) => { exportMaterialTableToPDF(columns, csvData, `Energy Saving Report-${getDateString()}`, 8, 18); },
                            // exportCsv: (columns, data) => ExportCsv(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`,","),
                            // exportPdf: (columns, data) => ExportPdf(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`),
                            // grouping: true,
                            search: true,
                            selection: false,
                            sorting: true,
                            pageSize: 10,
                            // rowStyle: (rowData) => ({
                            //   backgroundColor:
                            //     rowData?.ccmsNumber === selectedRowData?.ccmsNumber
                            //       ? "#f0f2f4"
                            //       : "",
                            // }),
                            headerStyle: {
                                backgroundColor: "#0071CE",
                                color: "#FFF",
                                fontSize: "0.9em",
                                textAlign: "center",
                            },
                            actionsColumnIndex: -1,
                            emptyRowsWhenPaging: false,
                        }}
                        localization={{
                            toolbar: {
                                searchPlaceholder: "Search",
                                exportCSVName: "Export as Excel",
                                exportPDFName: "Export as PDF",
                            },
                        }}
                    />     </div>
            </Box>

            <Dialog className="history-dialog" open={selectedRow != null || openDialog} onClose={hideAddUserDialog} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth="lg"
                sx={{
                    '& .MuiDialogContainer-root': {
                        maxWidth: '80%',
                        height: '90vh',
                    },
                }}
            >
                <DialogTitle id="editTime-dialog-title" onClose={hideAddUserDialog}>
                    {openDialog ? 'New' : 'Update'} Permission
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={hideAddUserDialog}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Name"
                            error={nameError.length > 0 ? true : false}
                            helperText={nameError}
                            type="text"
                            value={name}
                            onChange={(e) => { setName(e.target.value); setNameError('') }}
                        />
                    </FormControl>
                    <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
                        <TextField
                            margin="dense"
                            id="description"
                            label="description"
                            error={descriptionError.length > 0 ? true : false}
                            helperText={descriptionError}
                            type="text"
                            value={description}
                            onChange={(e) => { setDescription(e.target.value); setDescriptionError('') }}
                        />
                    </FormControl>
                    <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
                        <TextField
                            margin="dense"
                            id="key"
                            label="Key"
                            // InputProps={{
                            //     readOnly: !openDialog,
                            // }}
                            error={keyError.length > 0 ? true : false}
                            helperText={keyError}
                            type="text"
                            value={key}
                            onChange={(e) => { setKey(e.target.value); setKeyError('') }}
                        />
                    </FormControl>
                    <FormControl
                        className="dialog-form"
                        style={{ width: '100%', }}
                        disabled={!openDialog}
                        error={typeError.length > 0}
                    >
                        <InputLabel style={{ marginBottom: '20px' }} id="type-label">Type</InputLabel>

                        <div style={{ marginTop: '25px', width: '100%', display: 'flex', alignItems: 'center' }}>
                            <Select
                                style={{ width: '100%' }}
                                labelId="type-label"
                                id="type"
                                name="type"
                                value={type}
                                onChange={(e) => {
                                    handleInputChange(e);
                                    setTypeError('');
                                }}
                                label="Type"
                            >
                                {typeList.map((item) => (
                                    <MenuItem key={item} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                            {/* {!isAddingNewType && openDialog && (
                                <AddIcon onClick={() => {
                                    setIsAddingNewType(true);
                                    setType('');
                                }} className="w-6 h-6" />
                            )} */}
                        </div>

                    </FormControl>
                    <FormControl
                        className="dialog-form"
                        style={{ width: '100%', }}
                        error={groupError.length > 0}>
                        <InputLabel style={{ marginBottom: '20px' }} id="type-label">Group</InputLabel>

                        <div style={{ marginTop: '25px', width: '100%', display: 'flex', alignItems: 'center' }}>
                            <Select
                                style={{ width: '100%' }}
                                labelId="type-label"
                                id="group"
                                name="group"
                                value={group}
                                onChange={(e) => {
                                    setGroup(e.target.value);
                                    setGroupError('');
                                }}
                                label="Group"
                            >
                                {groupList.map((item) => (
                                    <MenuItem key={item} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                            {!isAddingNewGroup && (
                                <AddIcon onClick={() => {
                                    setIsAddingNewGroup(true);
                                    setGroup('');
                                }} className="w-6 h-6" />
                            )}
                        </div>


                    </FormControl>
                    {/* <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }} error={typeError.length > 0 ? true : false}>
                        <InputLabel id="type-label">Type</InputLabel>
                        <Select
                            required
                            labelId="type-label"
                            id="type"
                            name="Type"
                            value={type}
                            onChange={(e) => { setType(e.target.value); setTypeError('') }}
                            label="Zone">
                            {typeList.map((item) => (
                                <MenuItem key={item} value={item}>
                                    {item}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{typeError}</FormHelperText>
                    </FormControl> */}
                    {/* <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }} error={groupError.length > 0 ? true : false}>
                        <InputLabel id="group-label">group</InputLabel>
                        <Select
                            required
                            labelId="group-label"
                            id="group"
                            name="group"
                            value={group}
                            onChange={(e) => { setGroup(e.target.value); setGroupError('') }}
                            label="Zone">
                            {groupList.map((item) => (
                                <MenuItem key={item.group} value={item.group}>
                                    {item.group}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{groupError}</FormHelperText>
                    </FormControl> */}
                    <br></br>
                    <br></br>
                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">Status</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={status}
                            name="radio-buttons-group"
                        >
                            <FormControlLabel value={"Active"} control={<Radio onChange={(e) => { setStaus(true); setStausError('') }} />} label="Active" />
                            <FormControlLabel value={"Deactive"} control={<Radio onChange={(e) => { setStaus(false); setStausError('') }} />} label="Deactive" />
                        </RadioGroup>
                    </FormControl>
                    {statusError.length > 0 && <FormHelperText style={{ color: 'red' }}>{statusError}</FormHelperText>}

                </DialogContent>
                <DialogActions>
                    <Button onClick={hideAddUserDialog}>
                        Cancel
                    </Button>
                    <Button onClick={() => { openDialog ? add() : update() }} type="submit">
                        {openDialog ? "Create" : "Update"}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog className="history-dialog" open={isAddingNewType} onClose={() => setIsAddingNewType(false)} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth="lg"
                sx={{
                    '& .MuiDialogContainer-root': {
                        maxWidth: '80%',
                        height: '90vh',
                    },
                }}
            >
                <DialogTitle id="editTime-dialog-title" onClose={() => { setAddTypeError(''); setIsAddingNewType(false) }}>
                    Add type
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={() => { setAddTypeError(''); setIsAddingNewType(false) }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        id="type"
                        label="Type"
                        error={addTypeError.length > 0}
                        helperText={addTypeError}
                        type="text"
                        value={type}
                        onChange={(e) => {
                            setType(e.target.value);
                            setAddTypeError('');
                        }}
                        fullWidth
                        autoFocus
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAddTypeError(''); setIsAddingNewType(false) }}>
                        Cancel
                    </Button>
                    <Button onClick={() => {
                        if (type.trim()) {
                            if (!typeList.includes(type)) {
                                setTypeList([...typeList, type]);
                                setIsAddingNewType(false);
                            } else {
                                setAddTypeError('This option already exists');
                            }
                        }
                    }} type="submit">
                        {"Save type"}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog className="history-dialog" open={isAddingNewGroup} onClose={() => { setAddGroupError(''); setIsAddingNewGroup(false) }} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth="lg"
                sx={{
                    '& .MuiDialogContainer-root': {
                        maxWidth: '80%',
                        height: '90vh',
                    },
                }}
            >
                <DialogTitle id="editTime-dialog-title" onClose={() => { setAddGroupError(''); setIsAddingNewGroup(false) }}>
                    Add group
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={() => { setAddGroupError(''); setIsAddingNewGroup(false) }}                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        id="group"
                        label="Group"
                        error={addGroupError.length > 0}
                        helperText={addGroupError}
                        type="text"
                        value={group}
                        onChange={(e) => {
                            setGroup(e.target.value);
                            setAddGroupError('');
                        }}
                        fullWidth
                        autoFocus
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAddGroupError(''); setIsAddingNewGroup(false) }}  >
                        Cancel
                    </Button>
                    <Button onClick={() => {
                        if (group.trim()) {
                            if (!groupList.includes(group)) {
                                setGroupList([...groupList, group]);
                                setIsAddingNewGroup(false);
                            } else {
                                setAddGroupError('This option already exists');
                            }
                        }
                    }} type="submit">
                        {"Save group"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
    );
};

export default PermissionConfig;